import { gql } from '@apollo/client';

export const ITEM_FIELDS = gql`
  fragment ItemFields on Item {
    description
    invoiceId
    itemId
    name
    quantity
    unit
    unitPrice
  }
`;
